import React, { useState, useEffect } from 'react';
import { closeModalAction } from '../../../actions/modal';
import { useDispatch, useSelector } from 'react-redux';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { getCustomerMedia } from '../../../actions/chat';
import { editCustomerRequest } from '../../../actions/service_request';
import { CUSTOMER_MEDIA_SUCCESS } from '../../../types/chat';
import useHeicImage from '../../../hooks/useHeicImage';

const formName = 'editCustomerReport';

export default function EditCustomerReport({ openedConversationId }) {

    const dispatch = useDispatch();
    const [isSignOff, setIsSignOff] = useState([]);
    const [notIsSignOff, setNotIsSignOff] = useState([]);
    const isCustomerChatMediaListLoading = useSelector((state) => state.loading.isCustomerChatMediaListLoading);
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const customerSignoffMedia = useSelector((state) => state.chat.customerSignoffMedia);

    const defaultValues = {};

    useEffect(() => {
        dispatch(getCustomerMedia({ id: openedConversationId, }));
        return () => {
            dispatch({ type: CUSTOMER_MEDIA_SUCCESS, payload: { data: [] } })
        }
    }, [dispatch, openedConversationId]);

    const onDownClick = (media) => {
        let isSignOffList = isSignOff.filter((item) => item.id !== media.id);
        let notIsSignOffList = [...notIsSignOff, media];
        setIsSignOff(isSignOffList);
        setNotIsSignOff(notIsSignOffList);
    };

    const onUpClick = (media) => {
        let notIsSignOffList = notIsSignOff.filter((item) => item.id !== media.id);
        let isSignOffList = [...isSignOff, media];
        setIsSignOff(isSignOffList);
        setNotIsSignOff(notIsSignOffList);
    };

    useEffect(() => {
        if (Array.isArray(customerSignoffMedia) && customerSignoffMedia.length > 0) {
            let isSignOff = customerSignoffMedia
                .filter(
                    (media) =>
                        // media.type === 'image' &&
                        media.metadata &&
                        media.metadata.add_to_report === true
                );
            let notIsSignOff = customerSignoffMedia
                .filter(
                    (media) =>
                        // media.type === 'image' &&
                        (!media.metadata || media.metadata.add_to_report !== true)
                );
            setIsSignOff(isSignOff);
            setNotIsSignOff(notIsSignOff);
        }
    }, [customerSignoffMedia]);

    const onSubmit = () => {
        dispatch(editCustomerRequest({
            id: openedConversationId,
            media_ids: isSignOff.map((elem) => elem.id),
            formName
        }))
    };

    const methods = useForm({
        defaultValues: defaultValues,
        mode: 'all',
    });

    if (isCustomerChatMediaListLoading) {
        return (
            <div className='px-4 py-4'>
                <SkeltonCardTwo arr={[1, 2, 3, 4, 5]} height={25} padding={'0'} />
            </div>
        );
    }

    return (
        <Form
            submitButtonText='Save And Download'
            onSubmit={onSubmit}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4 overflow-hidden max-h-[10vh]'
            isLoading={formButtonLoading[formName]}
            methods={methods}
            onCancel={() => dispatch(closeModalAction())}
        >
            <div className='px-4 max-h-[50vh] overflow-y-auto'>
                <div>
                    <p className='text-scogoprimary text-font13 font-medium py-2'>Images in the Report</p>
                    <Media
                        list={isSignOff}
                        onClick={(media) => {
                            onDownClick(media);
                        }}
                        iconName='arrow_downward'
                    />
                </div>
                <div>
                    <p className='text-scogoprimary text-font13 font-medium py-2'>Images not in the Report</p>
                    <Media
                        list={notIsSignOff}
                        onClick={(media) => {
                            onUpClick(media);
                        }}
                        iconName='arrow_upward'
                    />
                </div>
            </div>
        </Form>
    );
}

const Media = ({ list, onClick, iconName }) => {
    if (list.length === 0) {
        return <span className='text-scogoclosed'>No Images</span>;
    }
    return (
        <div className='flex flex-wrap gap-2'>
            {list.map((media) => {
                return (
                    <MediaItemWithHeic key={media.id} media={media} onClick={onClick} iconName={iconName} />
                );
            })}
        </div>
    );
};

const MediaItemWithHeic = ({ media, onClick, iconName }) => {
    return (
        <div className='h-32 rounded-lg cursor-pointer overflow-hidden relative' style={{ width: '6.5vw' }}>
            <ImageWithHeic url={media.url} mimeType={media.mime_type} />
            {media.is_duplicate && (
                <div className='absolute top-0 left-0 bg-red-500 text-white text-xs px-1 py-0.5 rounded-bl'>
                    Duplicate
                </div>
            )}
            <span
                onClick={() => onClick(media)}
                style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
                className='z-50 material-icons text-scogoorange absolute rounded-full hover:bg-scogof8 hover:border border-scogoorange'
            >
                {iconName}
            </span>
        </div>
    );
};

const ImageWithHeic = ({ url, mimeType }) => {
    const { src: renderSrc, isConverting } = useHeicImage(url, mimeType);

    return (
        <div className="relative h-full w-full">
            {renderSrc && !isConverting && <img src={renderSrc} className={'border-2 rounded object-cover m-auto h-full w-full'} alt='' />}
            {isConverting && (
                <div className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 text-white text-xs'>
                    <span className='material-icons text-sm animate-spin'>refresh</span>
                </div>
            )}
        </div>
    );
};
